// // assets
// import { AuditOutlined,ApartmentOutlined, CarryOutOutlined } from '@ant-design/icons';

// // icons<FieldTimeOutlined />
// const icons = {
//  AuditOutlined,ApartmentOutlined,CarryOutOutlined
// };

// // ==============================|| MENU ITEMS - APPROVAL ||============================== //

// const approval= {
//   id: 'group-approval',
//   title: 'Approval',
//   type: 'group',
//   children: [
//     {
//       id: 'expenseApproval',
//       title: 'Expense Approval',
//       type: 'item',
//       url: '/expense-approval',
//       icon: icons.AuditOutlined,
//       breadcrumbs: false
//     },
//     {
//       id: 'l2expenseApproval',
//       title: 'Level 2 Expense Approval',
//       type: 'item',
//       url: '/l2expense-approval',
//       icon: icons.ApartmentOutlined,
//       breadcrumbs: false
//     },
//     {
//       id: 'adminexpenseApproval',
//       title: 'Admin Expense Approval',
//       type: 'item',
//       url: '/admin-expense-approval',
//       icon: icons.CarryOutOutlined,
//       breadcrumbs: false
//     }
//   ]
// };

// export default approval;



// // assets
// import { AuditOutlined,ApartmentOutlined, CarryOutOutlined } from '@ant-design/icons';

// // icons<FieldTimeOutlined />
// const icons = {
//  AuditOutlined,ApartmentOutlined,CarryOutOutlined
// };

// // ==============================|| MENU ITEMS - APPROVAL ||============================== //

// const approval= {
//   id: 'group-approval',
//   title: 'Approval',
//   type: 'collapse',
//   icon: icons.AuditOutlined,
//   children: [
//     {
//       id: 'expenseApproval',
//       title: 'Expense Approval',
//       type: 'item',
//       url: '/expense-approval',
//       icon: icons.AuditOutlined,
//       breadcrumbs: false
//     },
//     {
//       id: 'l2expenseApproval',
//       title: 'Level 2 Expense Approval',
//       type: 'item',
//       url: '/l2expense-approval',
//       icon: icons.ApartmentOutlined,
//       breadcrumbs: false
//     },
//     {
//       id: 'adminexpenseApproval',
//       title: 'Admin Expense Approval',
//       type: 'item',
//       url: '/admin-expense-approval',
//       icon: icons.CarryOutOutlined,
//       breadcrumbs: false
//     }
//   ]
// };

// export default approval;



// assets
import { AuditOutlined, ApartmentOutlined, CarryOutOutlined } from '@ant-design/icons';

const icons = { AuditOutlined, ApartmentOutlined, CarryOutOutlined };

const roles = [0,1,2,3,4,5,6,7,8,9,10,11,12];

const approval = {
  id: 'group-approval',
  title: 'Approval',
  type: 'collapse',
  icon: icons.AuditOutlined,
  roles,
  children: [
    {
      id: 'expenseApproval',
      title: 'L1 Expense Approval',
      type: 'item',
      url: '/expense-approval',
      icon: icons.AuditOutlined,
      breadcrumbs: false,
      roles
    },
    {
      id: 'l2expenseApproval',
      title: 'L2 Expense Approval',
      type: 'item',
      url: '/l2expense-approval',
      icon: icons.ApartmentOutlined,
      breadcrumbs: false,
      roles
    },
    {
      id: 'adminexpenseApproval',
      title: 'Admin Expense Approval',
      type: 'item',
      url: '/admin-expense-approval',
      icon: icons.CarryOutOutlined,
      breadcrumbs: false,
      roles
    },
    {
      id: 'expenseApprovalNew',
      title: 'Expense Approval New1',
      type: 'item',
      url: '/expense-approval-new',
      icon: icons.CarryOutOutlined,
      breadcrumbs: false,
      roles
    }
    ,
    {
      id: 'expenseApprovalNewL2',
      title: 'Expense Approval New L21',
      type: 'item',
      url: '/expense-approval-new-l2',
      icon: icons.CarryOutOutlined,
      breadcrumbs: false,
      roles
    }


,
    {
      id: 'expenseApprovalNewL3',
      title: 'Expense Approval New L311',
      type: 'item',
      url: '/expense-approval-new-l3',
      icon: icons.CarryOutOutlined,
      breadcrumbs: false,
      roles
    }

  ]
};

export default approval;
